
import Vue from 'vue';
import i18n from '@/i18n';
import Analytics from '@/helpers/analytics';
import SentryClient from '@/helpers/sentry';
import { TranslateResult } from 'vue-i18n';
import { TermsOfUse } from '@descomplica/vue-components';
import { EVENT_LABELS } from '@/helpers/analytics/labels';

import TermsOfUseService from '@/services/TermsOfUse';
import { UserModel } from '@descomplica/dex-models';

const newTermsUpdateDialogLastVerify: string = 'new-terms-update-dialog-last-verify';

export default Vue.extend({
  components: {
    TermsOfUse,
  },
  data() {
    return {
      showTermsOfUse: false,
    };
  },
  computed: {
    title(): TranslateResult {
      return i18n.t('termsOfUse.title');
    },
    helperLink(): string {
      return 'https://atendimento.descomplica.com.br/hc/';
    },
    privacyPolicyLink(): string {
      return 'https://descomplica.com.br/sobre/politica-de-privacidade/';
    },
    termsLink(): string {
      return 'https://descomplica.com.br/sobre/termos-de-uso/';
    },
    currentUser(): UserModel {
      return this.$store.getters.currentUser;
    },
    currentTimestamp(): string {
      return new Date().getTime().toString();
    },
    canViewTermsOfUse(): Boolean {
      return this.$store.getters.canViewTermsOfUse && this.showTermsOfUse;
    },
  },
  async mounted() {
    await this.startTermsOfUse();
  },
  methods: {
    sendTracking(trackingName: string): void {
      Analytics.trackEvent(trackingName, {
        email: this.currentUser.email,
        origin_url: window.location.hostname + window.location.pathname,
      });
    },
    async startTermsOfUse(): Promise<void> {
      try {
        const { data } = await TermsOfUseService.getAccepted();

        if (!data.accepted) {
          this.showTermsOfUse = true;
          this.sendTracking(EVENT_LABELS.termsOfUseShowUp);
          return;
        }

        localStorage.setItem(newTermsUpdateDialogLastVerify, this.currentTimestamp);
      } catch (e: any) {
        SentryClient.captureError(e);
      }
    },
    async onClickAccept(): Promise<void> {
      this.showTermsOfUse = false;

      localStorage.setItem(newTermsUpdateDialogLastVerify, this.currentTimestamp);

      try {
        await TermsOfUseService.sendAccepted();
        this.sendTracking(EVENT_LABELS.termsOfUseAccepted);
      } catch (e: any) {
        SentryClient.captureError(e);
      }
    },
  },
});
